import { Controller } from "@hotwired/stimulus"

// Disables the onboarding step's submit button until every tagged field has
// a non-empty value. Disabled fields (e.g. region selects for countries with
// no subdivisions) are treated as already satisfied so the user isn't blocked.
export default class extends Controller {
  static targets = ["field", "submit"]

  connect() {
    this.validate()
  }

  validate() {
    if (!this.hasSubmitTarget) return

    const allFilled = this.fieldTargets.every((field) => {
      if (field.disabled) return true
      return field.value != null && String(field.value).trim().length > 0
    })

    this.submitTarget.disabled = !allFilled
    this.submitTarget.classList.toggle("pf-btn--disabled", !allFilled)
  }
}
